import { Component } from "@mna/react";
import Form from "@mna/react-ui/Form";
import schema from "@mna/schema";
import create from "assets/img/Create_img.png";
import { defaultContextId, defaultOrganizationId } from "client.config";
import LoadingScreen from "features/LoadingScreen";
import i18next from "i18next";
import { Trans } from "react-i18next";
import Modal from "react-modal";
import "../../assets/fonts/HelveticaNeue/stylesheet.css";
import "../../styles/mail.scss";
import i18n from "../../i18n";

var organizationId, oBranchId, language;
class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailErrorMsg: "",
      email: "",
      isMailSent: false,
    };
  }

  checkAndReturnQueryParam(value) {
    var hasValue = new URLSearchParams(this.props.location.search).has(value);
    if (hasValue) {
      return new URLSearchParams(this.props.location.search).get(value);
    } else {
      return "";
    }
  }

  componentWillMount() {
    const { state } = this.props;
    if (this.props.location.search) {
      organizationId = this.checkAndReturnQueryParam("orgId");
      oBranchId = this.checkAndReturnQueryParam("branchId");

      if (organizationId === "" || oBranchId === "") {
        organizationId = defaultOrganizationId;
        oBranchId = defaultContextId;
      }
      state.triageRequest.SignUpOrganizationId = organizationId;
      state.triageRequest.SignUpOBranchId = oBranchId;
    } else {
      organizationId = defaultOrganizationId;
      oBranchId = defaultContextId;
      state.triageRequest.SignUpOrganizationId = organizationId;
      state.triageRequest.SignUpOBranchId = oBranchId;
    }

    language = this.checkAndReturnQueryParam("lng");

    if (language === "") {
      language = "en";
    }
    i18n.changeLanguage(language);
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem("languageCode", language);
    }
  }

  callSetStateModal(setState, value) {
    setState({
      showExistsModal: value,
    });
  }

  async callSendMail(state, actions, setState, emailId) {
    var isEmailSent = await actions.sendMailConfirmation(
      state,
      setState,
      actions,
      emailId,
      organizationId,
      oBranchId,
      language
    );
    setState({
      isLoading: false,
    });
    this.setState({
      isMailSent: isEmailSent,
    });
  }

  render() {
    const {
      state,
      setState,
      state: { triageRequest },
      actions,
      history,
    } = this.props;

    const formSchema = schema(({ string }) => ({
      email: string,
    }));

    return (
      <div className="page-section-2">
        <Form
          className="content content-unset"
          fields={triageRequest.serviceRequest}
          onValidate={(data) => {
            const errors = {};
            let emailError = "";
            var erroredEmail = data.email;
            var scheme = formSchema(data);
            if (scheme !== null && scheme.email === "REQUIRED")
              errors.email = "REQUIRED";

            if (data.email === "") {
              emailError = (
                <Trans i18nKey="userregistration.validation.email">
                  Email address cannot be empty
                </Trans>
              );
              errors.email = "REQUIRED";
            } else if (
              /^([A-Za-z0-9_+\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
                erroredEmail.trim()
              ) === false
            ) {
              emailError = (
                <Trans i18nKey="userregistration.validation.email_msg1">
                  Enter the Valid Email Address
                </Trans>
              );
              errors.email = "REQUIRED";
            }
            this.setState({ emailErrorMsg: emailError });

            if (Object.keys(errors).length) return errors;
          }}
          onSubmit={async (values) => {
            var emailId = { email: values.email.toLowerCase() };
            state.triageRequest.mailValidation = emailId;
            var identities = await actions.callExternalIndentities(
              state,
              setState,
              actions
            );
            if (identities !== undefined) {
              if (identities && identities.response.results.length >= 1) {
                this.callSetStateModal(setState, true);
              } else {
                this.callSetStateModal(setState, false);
                var emailId = state.triageRequest.mailValidation.email;
                setState({
                  isLoading: true,
                });
                this.callSendMail(state, actions, setState, emailId);
              }
            }
          }}
        >
          {({ fields, invalidFields }) => (
            <div className="container-2 w-container">
              <LoadingScreen isLoading={state.isLoading}>
                {!this.state.isMailSent ? (
                  <div id="inputEmail" className="w-row">
                    <div className="column w-col w-col-1 w-col-tiny-tiny-stack"></div>
                    <div className="column-2 w-col w-col-5 w-col-tiny-tiny-stack">
                      <div>
                        <span id="createaccount">
                          <Trans i18nKey="userregistration.step-1heading">
                            Let’s start by verifying your e-mail
                          </Trans>
                        </span>
                        <div id="already">
                          <span>
                            <Trans i18nKey="userregistration.accountexistsmsg">
                              Already have an account?{" "}
                            </Trans>
                          </span>
                          <span
                            id="sign"
                            onClick={(e) => actions.startAzureLogin()}
                          >
                            <Trans i18nKey="userregistration.signin">
                              Sign in
                            </Trans>
                          </span>
                        </div>

                        <input
                          id="email-input"
                          type="text"
                          autocomplete="off"
                          name="email"
                          placeholder={i18next.t("userregistration.emailwm")}
                          defaultValue={
                            state.triageRequest.mailValidation &&
                              state.triageRequest.mailValidation.email
                              ? state.triageRequest.mailValidation.email.trim()
                              : fields.email
                          }
                          className={invalidFields.email ? "is-error" : ""}
                        />
                        <div className="errormessage">
                          {this.state.emailErrorMsg}
                        </div>

                        <div className="continue-btn">
                          <button
                            type="submit"
                            className="button1 btn standby-button-gradient standby-button-gradient-blue"
                          >
                            <Trans i18nKey="findcareoption.Covid.Continue_text">
                              Continue
                            </Trans>
                          </button>
                        </div>

                        <p
                          className="cancel"
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <Trans i18nKey="userregistration.cancel">
                            Cancel
                          </Trans>
                        </p>
                      </div>
                    </div>
                    <div className="w-col w-col-6 w-col-tiny-tiny-stack">
                      <img src={create} className="t-img" />
                    </div>
                  </div>
                ) : (
                  <div id="sentEmail" className="w-row">
                    <div className="column w-col w-col-1 w-col-tiny-tiny-stack"></div>
                    <div className="column-2 w-col w-col-5 w-col-tiny-tiny-stack h-25">
                      <span id="createaccount">
                        <Trans i18nKey="userregistration.step-1verifyemail">
                          Please check your e-mail to verify your account and
                          continue setup
                        </Trans>
                      </span>
                      <h6>
                        <Trans i18nKey="userregistration.step-1subnote">
                          Please check your spam folder if you have not received
                          the e-mail verification
                        </Trans>
                      </h6>
                    </div>
                    <div className="w-col w-col-6 w-col-tiny-tiny-stack">
                      <img src={create} className="t-img" />
                    </div>
                  </div>
                )}
              </LoadingScreen>
            </div>
          )}
        </Form>

        <Modal
          isOpen={state.showExistsModal}
          contentLabel="customStyles"
          className="ReactModal__Content_triagepopup"
          overlayClassName="ReactModal__Overlay_triagepopup"
        >
          <label className="label-header">
            <Trans i18nKey="userregistration.alert">ALERT</Trans>
          </label>
          <label className="label-header">
            <Trans i18nKey="userregistration.emailexists-msg1">
              An account with email address{" "}
            </Trans>
            '
            {state.triageRequest.mailValidation &&
              state.triageRequest.mailValidation.email
              ? state.triageRequest.mailValidation.email.trim()
              : ""}
            '
            <Trans i18nKey="userregistration.emailexists-msg2">
              {" "}
              already exists. Please click
            </Trans>{" "}
            <span className="sign" onClick={(e) => actions.startAzureLogin()}>
              <Trans i18nKey="userregistration.emailexists-login">log in</Trans>
            </span>{" "}
            <Trans i18nKey="userregistration.emailexists-msg3">
              to continue using the service. If you would like to reset your
              password, please click on the forgot password link on login
              screen.
            </Trans>
          </label>
          <div className="pop_button">
            <button
              type="submit"
              className="popup-ok"
              onClick={(e) => {
                this.callSetStateModal(setState, false);
              }}
            >
              <Trans i18nKey="userregistration.emailexists-okbtn">Ok</Trans>
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}
export default Users;
